import React from 'react'
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import GroomingPageFeature from '../components/GroomingPageFeature'
import BreadCrumb from '../components/BreadCrumb'
import CatGroomingPagePrice from '../components/CatGroomingPagePrice'
import { Helmet } from 'react-helmet'
import ScrollNavbar from '../components/ScrollNavbar'
import CustomerFeedback from '../components/main/CustomerFeedback'

const CatGroomingPage = () => {
  return (
    <div>
      
<Helmet>
        <title>Purr-fect Cat Grooming at Home | FluffyTouch</title>
        <meta
          name="description"
          content="Gentle at-home cat grooming! Lion cuts, nail trims & de-matting in your space. Stress-free for shy cats. 30% OFF first booking. Call now!"
        />
      </Helmet>
      <ScrollNavbar/> 
        <Navbar/>
        <BreadCrumb name="Cat Grooming" title="Best Cat Grooming Services At Home"/>

<CatGroomingPagePrice/>

        <GroomingPageFeature/>

        <div className='ft-customer-rev-of-get-grooming-page'>

        <CustomerFeedback viewMoreValue="active"/>
        </div>

        <Footer/>
        
    </div>
  )
}

export default CatGroomingPage